import { SignIn } from "@clerk/react";
import { SpinnerGap } from "@phosphor-icons/react";

function getReturnUrl(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("returnTo");
}

export function LoginPage() {
  const returnTo = getReturnUrl() ?? "/o/unknown/overview";

  return (
    <div className="flex min-h-screen items-center justify-center">
      <SpinnerGap className="sr-only" />
      <SignIn forceRedirectUrl={returnTo} />
    </div>
  );
}
